import {
  Button,
  Grid,
  Link,
  SvgIcon,
  TableSortLabel,
  Typography,
} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { IconFlagCA, IconFlagUS } from "material-ui-flags";
import SearchBar from "material-ui-search-bar";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useHistory, useLocation } from "react-router-dom";
import { ReactComponent as INLogo } from "../images/inflag.svg";
import http from "../services/httpService";
import staticFiles from "../services/staticApi";
import {
  getDate,
  handleSort,
  investmentDetailsPath,
  searchFilter,
  subscriptionManagerPath,
} from "../utils/varialbles";

const getFlags = (country) => {
  let CountryMapper = {
    INR: (
      <SvgIcon>
        <INLogo />
      </SvgIcon>
    ),
    USD: IconFlagUS,
    CAD: IconFlagCA,
  };
  if (country && CountryMapper[country] && country !== "India") {
    return React.createElement(CountryMapper[country]);
  } else {
    return CountryMapper["India"];
  }
};

const getCurrency = (name) => {
  let currencyMapper = {
    INR: "₹",
    USD: "$",
    CAD: "C$",
  };
  if (name && currencyMapper[name]) {
    return currencyMapper[name];
  } else {
    return currencyMapper["INR"];
  }
};
const useStyles = makeStyles({
  root: {
    width: "100%",
  },
});
const columns = [
  { label: "User ID", id: "userID", minWidth: 150 },

  { label: "Asset Type", id: "type", minWidth: 150 },
  { label: "Advised Investment Name", id: "name", minWidth: 200 },
  {
    label: "Advised Investment Amount",
    id: "advisedval",
    minWidth: 200,
    format: "currency",
  },
  { label: "Actual Investment Name", id: "name", minWidth: 200 },
  {
    label: "Actual Invested Amount",
    id: "investedval",
    minWidth: 200,
    format: "currency",
  },
  { label: "Advised Date", id: "Order_ID", minWidth: 150, format: "Date" },
  {
    label: "Invested Date",
    id: "Transaction_ID",
    minWidth: 150,
    format: "Date",
  },

  {
    label: "Percentage of portfolio",
    id: "gain",
    minWidth: 150,
    align: "center",
  },
  {
    label: "Current Value",
    id: "currentval",
    minWidth: 150,
    align: "center",
    format: "currency",
    replaceWith: "currentNAV",
    case: "Mutual Funds",
    caseField: "type",
  },
  { label: "Exchange", id: "exchange", minWidth: 150, align: "center" },
  { label: "Symbol", id: "symbol", minWidth: 150, align: "center" },
  { label: "CAGR Return", id: "cagr", minWidth: 150, align: "center" },
  { label: "Absolute Return", id: "absreturn", minWidth: 150, align: "center" },
  { label: "Status", id: "status", minWidth: 150, align: "center" },
];
function InvestorPortFolioOverAll() {
  const classes = useStyles();
  const history = useHistory();
  const [publishedActive, setPublishedActive] = useState(false);
  const [archivedActive, setArchivedActive] = useState(true);
  const location = useLocation();
  const myparam = location.state;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState([]);
  const [searched, setSearched] = React.useState("");
  const [orignalRows, setOriginalRows] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState("cust__createddt");
  const [order, setOrder] = React.useState("asc");
  const requestSearch = (searchedVal) => {
    let rowsTemp = [...orignalRows];
    setSearched(searchedVal);
    setPage(0);
    // setRows(searchFilter(searchedVal, rowsTemp));
    const query = searchedVal ? searchedVal : searched;
    getData(query);
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };
  const [overview, setOverview] = React.useState({});
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleRequestSort = (e, property, format) => {
    let isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let tempRows = [...rows];
    let finalRows = handleSort(property, format, tempRows, isAsc);

    setRows(finalRows);
    setPage(0);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const viewInvestmentDetails = (object) => {
    history.push({
      pathname: investmentDetailsPath,
      state: object,
    });
  };
  // useEffect(() => {
  //     toast.loading("Please wait..")

  //     http.get("/overall_portfolio").then((response) => {
  //         toast.dismiss()

  //         if (response && response.data && response.data.Data && Array.isArray(response.data.Data) && response.data.Data.length > 0) {
  //             setOriginalRows(response.data.Data.flat());
  //             setRows(response.data.Data.flat())
  //         }
  //         if (response && response.data && response.data.Data && response.data.Data.overview) {
  //             setOverview(response.data.Data)
  //         }
  //     }).catch((error) => {
  //         toast.dismiss()

  //     })
  // }, []);
  const [totalRowCount, setTotalRowCount] = React.useState(0);
  const getPaginationURL = (url, newQuery) => {
    const query = newQuery ? newQuery : searched;
    if (query) {
      return `${url}?page=${page + 1
        }&rowsPerPage=${rowsPerPage}&search=${query}`;
    } else {
      return `${url}?page=${page + 1}&rowsPerPage=${rowsPerPage}`;
    }
  };
  const getData = (newQuery) => {
    const baseURL = "/overall_portfolio";
    setOriginalRows([]);
    setRows([]);
    toast.dismiss();
    toast.loading("Please wait..");
    http.get(getPaginationURL(baseURL, newQuery)).then((response) => {
      toast.dismiss();
      // http.get("/investment_manager").then((response) => {
      if (response && response.data && response.data.statusCode === 0) {
        setOriginalRows(response.data.Data.flat());
        setRows(response.data.Data.flat());
        setTotalRowCount(response.data.totalRowCount);
      }
    });
  };
  useEffect(() => {
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("internalFilter");
    localStorage.removeItem("selectedfiltersdata");
    localStorage.removeItem("selectedinvestorfiltersdata");
    getData();
  }, [page, rowsPerPage]);
  // useEffect(()=>{
  //     const baseURL = '/overall_portfolio';
  //     setOriginalRows([]);
  //     setRows([]);
  //     http.get(getPaginationURL(baseURL)).then((response) => {
  //     // http.get("/investment_manager").then((response) => {
  //         // ('owo');
  //         // (response);
  //         if(response && response.data && response.data.statusCode===0){
  //             setOriginalRows(response.data.Data.flat());
  //             setRows(response.data.Data.flat());
  //             setTotalRowCount(response.data.totalRowCount);
  //         }
  //     });
  // }, [page, rowsPerPage])
  const makeActive = (event) => {
    setPublishedActive(!publishedActive);
    setArchivedActive(!archivedActive);
    if (event === "overview") {
      if (myparam && myparam.customer_id) {
        history.push({
          pathname: subscriptionManagerPath,
          state: myparam,
        });
      }
    }
  };
  return (
    <div className={classes.root}>
      <Paper style={{ marginBottom: 10, height: 100 }}>
        <Grid container>
          <Grid item xs={12} sm={6} md={6}>
            <Typography variant="h6" style={{ marginTop: 25, paddingLeft: 20 }}>
              Portfolio
            </Typography>
          </Grid>
          {overview && overview.currency ? (
            <Grid item xs={12} sm={6} md={6}>
              <div
                style={{
                  background: "#F5F7FA 0% 0% no-repeat padding-box",
                  height: "80px",
                  marginTop: 12,
                  marginRight: 15,
                  borderRadius: 10,
                }}
              >
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    style={{ marginTop: 10, paddingLeft: 10 }}
                  >
                    <Typography variant="h6">
                      {getCurrency(overview.currency) +
                        " " +
                        overview.investedval}
                    </Typography>
                    <Typography variant="caption">Invested Amount</Typography>
                  </Grid>
                  <Grid item xs={12} sm={3} style={{ marginTop: 10 }}>
                    <Typography variant="h6">
                      {getCurrency(overview.currency) +
                        " " +
                        overview.currentval}
                    </Typography>
                    <Typography variant="caption">Current Value</Typography>
                  </Grid>
                  <Grid item xs={12} sm={3} style={{ marginTop: 10 }}>
                    <Typography variant="h6">
                      {getCurrency(overview.currency) +
                        " " +
                        overview.savartgain}
                    </Typography>
                    <Typography variant="caption">
                      Savart Portfolio Gain
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={3} style={{ marginTop: 10 }}>
                    <Typography variant="h6">
                      {getCurrency(overview.currency) +
                        " " +
                        overview.clientgain}
                      <Typography
                        variant="caption"
                        style={{ color: "#11BE74", paddingLeft: 10 }}
                      >
                        {overview.clientgainper}
                        {" %"}
                        <ArrowDropUpIcon />
                      </Typography>
                    </Typography>
                    <Typography variant="caption">
                      Client Portfolio Gain
                    </Typography>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          ) : (
            ""
          )}
        </Grid>
      </Paper>
      <Paper className={classes.root}>
        <div className="prospectsearchfilterboth">
          <SearchBar
            value={searched}
            onChange={(searchVal) => requestSearch(searchVal)}
            onCancelSearch={() => cancelSearch()}
            style={{ height: "auto", padding: "5px 0", marginTop: 5 }}
          //   className={"mt30"}
          />
          <TablePagination
            rowsPerPageOptions={[5, 10, 15, 25, 50, 100, 500, 1500]}
            component="div"
            // count={rows.length}
            count={totalRowCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
        <TableContainer
          // style={{ height: "700px" }}
          className={classes.container}
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id + column.label.trim()}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={(e) =>
                        handleRequestSort(e, column.id, column.format)
                      }
                    >
                      {column.label}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {
                rows.length !== 0 ? (
                  <>
                    {rows.map((row, index) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={index + "a"}
                        >
                          {columns.map((column, index) => {
                            const value = row[column.id];
                            return (
                              <TableCell
                                key={index + column.id + column.label.trim()}
                                align={column.align}
                              >
                                {column.format && typeof value === "number" ? (
                                  column.format(value)
                                ) : column.id === "detailsButton" ? (
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    style={{ borderRadius: 20 }}
                                    onClick={() => viewInvestmentDetails(row)}
                                  >
                                    View Details
                                  </Button>
                                ) : column.format === "Date" ? (
                                  getDate(value)
                                ) : column.format === "boolean" && row[column.id] ? (
                                  "Yes"
                                ) : column.format === "boolean" && !row[column.id] ? (
                                  "No"
                                ) : column.format === "link" &&
                                  value &&
                                  value !== "" ? (
                                  <Link
                                    variant="body2"
                                    href={staticFiles + value}
                                    target="_blank"
                                  >
                                    {value}
                                  </Link>
                                ) : column.format === "currency" &&
                                  column.replaceWith &&
                                  row[column.caseField] === column.case &&
                                  row[column.replaceWith] ? (
                                  <>
                                    <span>{getFlags(row["currency"])}</span>
                                    <span
                                      style={{
                                        position: "relative",
                                        top: "-5px",
                                        paddingLeft: 15,
                                      }}
                                    >
                                      {getCurrency(row.currency) +
                                        " " +
                                        row[column.replaceWith]}
                                    </span>
                                  </>
                                ) : column.format === "currency" && value ? (
                                  <>
                                    <span>{getFlags(row["currency"])}</span>
                                    <span
                                      style={{
                                        position: "relative",
                                        top: "-5px",
                                        paddingLeft: 15,
                                      }}
                                    >
                                      {getCurrency(row.currency) + " " + value}
                                    </span>
                                  </>
                                ) : (
                                  value
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                  </>
                ) : (
                  <TableCell
                    colspan="7"
                    style={{ "text-align": "center", margin: "10px 0px" }}
                  >
                    Records Not Available
                  </TableCell>
                )
              }

            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
}

export default InvestorPortFolioOverAll;
